import { Controller } from "@hotwired/stimulus"

// Handles push-style drawer that slides in from the side and pushes main content
export default class extends Controller {
  static targets = ["toggle", "content", "sidebar"]

  connect() {
    // Initialize state from checkbox
    this.updateDrawerState()
  }

  toggleDrawer() {
    this.updateDrawerState()
  }

  updateDrawerState() {
    const isOpen = this.toggleTarget.checked

    if (isOpen) {
      this.sidebarTarget.classList.remove("hidden")
      this.sidebarTarget.classList.add("flex")
    } else {
      this.sidebarTarget.classList.add("hidden")
      this.sidebarTarget.classList.remove("flex")
    }
  }

  // Allow external closing (e.g., from close button in sidebar)
  close() {
    this.toggleTarget.checked = false
    this.updateDrawerState()
  }

  // Allow external opening
  open() {
    this.toggleTarget.checked = true
    this.updateDrawerState()
  }
}
